import React from 'react';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import SvgBall01 from '../generated/svg/ball-01';
import SvgBall02 from '../generated/svg/ball-02';
import SvgBall03 from '../generated/svg/ball-03';
import SvgBall04 from '../generated/svg/ball-04';
import SvgBall05 from '../generated/svg/ball-05';
import SvgBall06 from '../generated/svg/ball-06';
import SvgBall07 from '../generated/svg/ball-07';
import SvgBall08 from '../generated/svg/ball-08';
import SvgBall09 from '../generated/svg/ball-09';
import SvgBall10 from '../generated/svg/ball-10';
import SvgBall11 from '../generated/svg/ball-11';
import SvgBall12 from '../generated/svg/ball-12';
import SvgBall13 from '../generated/svg/ball-13';
import SvgBall14 from '../generated/svg/ball-14';
import SvgBall15 from '../generated/svg/ball-15';
import SvgBall16 from '../generated/svg/ball-16';
import SvgBall17 from '../generated/svg/ball-17';
import SvgBall18 from '../generated/svg/ball-18';
import SvgBall19 from '../generated/svg/ball-19';
import SvgBall20 from '../generated/svg/ball-20';
import SvgBall21 from '../generated/svg/ball-21';
import SvgBall22 from '../generated/svg/ball-22';
import SvgBall23 from '../generated/svg/ball-23';
import SvgBall24 from '../generated/svg/ball-24';
import SvgBall25 from '../generated/svg/ball-25';
import SvgBall26 from '../generated/svg/ball-26';
import SvgBall27 from '../generated/svg/ball-27';
import SvgBall28 from '../generated/svg/ball-28';
import { AutoImage } from './auto-image';

const Outer = styled.div`
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
`

export const HeadItem = styled.div`
  flex: 0 0 calc(100% / 7);
  box-sizing: border-box;
  @media (max-width: 40rem) {
    flex: 0 0 calc(100% / 4);
  }
`

export const HeadItemInner = styled.div`
  position: relative;
`

export const Face = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transition-timing-function: cubic-bezier(.175, .885, .32, 1.275);
  transition-duration: .5s;
  transition-property: transform, opacity;
  transform: rotateY(0deg);
  padding: 15%;
  box-sizing: border-box;
  opacity: 1;
  ${HeadItem}:hover & {
    transform: rotateY(180deg);
    opacity: 0;
  }
  svg {
    width: 100%;
    height: auto;
  }
`

export const Back = styled.div`
  width: 100%;
  transition-timing-function: cubic-bezier(.175, .885, .32, 1.275);
  transition-duration: .5s;
  transition-property: transform, opacity;
  transform: rotateY(-180deg);
  opacity: 0;
  mix-blend-mode: multiply;
  ${HeadItem}:hover & {
    opacity: 1;
    transform: rotateY(0deg);
  }
  img {
    width: 100%;
    height: auto;
  }
`

const HeadVideoOuter = styled.div`
  width: 100%;
  overflow: hidden;
`

const HeadVideo = styled.video`
  display: block;
  width: calc(100% + 8px);
  height: auto;
  margin: -4px;
`

export const TopBanner:FunctionComponent = () => {
  const isVideo = window.location.search === '?video'
  return <Outer>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall01 /></Face>
        <Back><AutoImage src={`/images/0001.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall02 /></Face>
        <Back><AutoImage src={`/images/0002.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall03 /></Face>
        <Back><AutoImage src={`/images/0003.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall04 /></Face>
        <Back><AutoImage src={`/images/0004.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall05 /></Face>
        <Back><AutoImage src={`/images/0005.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall06 /></Face>
        <Back><AutoImage src={`/images/0006.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall07 /></Face>
        <Back><AutoImage src={`/images/0007.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall08 /></Face>
        <Back><AutoImage src={`/images/0008.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall09 /></Face>
        <Back><AutoImage src={`/images/0009.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall10 /></Face>
        <Back><AutoImage src={`/images/0010.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall11 /></Face>
        <Back><AutoImage src={`/images/0011.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall12 /></Face>
        <Back><AutoImage src={`/images/0012.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall13 /></Face>
        <Back><AutoImage src={`/images/0013.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall14 /></Face>
        <Back><AutoImage src={`/images/0014.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall15 /></Face>
        <Back><AutoImage src={`/images/0015.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall16 /></Face>
        <Back><AutoImage src={`/images/0016.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall17 /></Face>
        <Back><AutoImage src={`/images/0017.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall18 /></Face>
        <Back><AutoImage src={`/images/0018.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall19 /></Face>
        <Back><AutoImage src={`/images/0019.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall20 /></Face>
        <Back><AutoImage src={`/images/0020.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall21 /></Face>
        <Back><AutoImage src={`/images/0021.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall22 /></Face>
        <Back><AutoImage src={`/images/0022.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall23 /></Face>
        <Back><AutoImage src={`/images/0023.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall24 /></Face>
        <Back><AutoImage src={`/images/0024.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall25 /></Face>
        <Back><AutoImage src={`/images/0025.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall26 /></Face>
        <Back><AutoImage src={`/images/0026.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall27 /></Face>
        <Back><AutoImage src={`/images/0027.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
    <HeadItem>
      <HeadItemInner>
        <Face><SvgBall28 /></Face>
        <Back><AutoImage src={`/images/0028.jpg`} width="300" height="300" /></Back>
      </HeadItemInner>
    </HeadItem>
  </Outer>
}